import { SUBTYPES, TStoryContentElementType } from "@dl/declarations";
import * as yup from "yup";
import { StoryFormData, initialValues as storyInitialValues } from "./story";

export type TemplateFormData = {
  _id?: string;
  info: {
    name: string;
    description: string;
  };
} & Partial<StoryFormData>;

export const initialValues: TemplateFormData = {
  info: {
    name: "",
    description: "",
  },
  ...storyInitialValues,
};

const partialStorySchema = yup.object().shape({
  subtype: yup.string().required().label("Story Subtype"),
  verticals: yup
    .array()
    .of(yup.string())
    .label("Verticals")
    .test(
      "only-one-research-vertical",
      "Only one research section is allowed",
      (value, context) => {
        if (context?.parent?.subtype === SUBTYPES.RESEARCH.ID) {
          return (value?.length || 0) <= 1;
        }

        return true;
      }
    ),
  primary_vertical: yup.string().label("Primary Vertical"),
  sub_vertical: yup.string().label("Sub Vertical"),
  authors: yup.array().of(yup.string()).label("Authors"),
  tags: yup.array().of(yup.string()).optional().label("Tags"),
  guests: yup
    .array()
    .of(
      yup.object().shape({
        first_name: yup.string().label("Guest First Name"),
        last_name: yup.string().label("Guest Last Name"),
      })
    )
    .label("Guests"),
  content_elements: yup
    .array()
    .of(yup.object<TStoryContentElementType>())
    .label("Template content"),
});

export const schema = partialStorySchema.shape({
  info: yup.object().shape({
    name: yup.string().required().label("Name"),
    description: yup.string().required().label("Description"),
  }),
});
